"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ListItem = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    title,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_componentsBase.ListItem, {
    ref: ref,
    ...rest,
    children: [Boolean(title) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      variant: {
        size: 'h4'
      },
      children: title
    }), children]
  });
});
ListItem.displayName = 'ListItem';
ListItem.propTypes = {
  children: _propTypes.default.node.isRequired,
  title: _propTypes.default.string
};
var _default = exports.default = ListItem;